<template>
  <div ref="main">
    <div v-if="!customHeaderHtml">
      <div
        class="container"
        v-if="((alternateSettings.layout === 'Textbox Adjacent') || (alternateSettings.layout === 'Textbox Overlaid'))"
      >
        <div
          class="collection-hero t-a"
          v-if="alternateSettings.layout === 'Textbox Adjacent'"
          :class="currentBgColor"
        >
          <div
            class="collection-hero__with-image"
            v-if="heroSettings.imageUrl"
            :class="[layoutClass, layoutAlignmentClass]"
          >
            <div class="collection-hero__text" :class="textAlignmentClass">
              <collection-breadcrumbs-b v-bind="breadcrumbs"></collection-breadcrumbs-b>
              <h1
                :class="[currentHeadingColor, 'h3']"
              >{{currentHeadingText}}</h1>
              <p
                class="body-sm-mobile body-md-tablet-up"
                v-if="heroSettings.copy"
                :class="currentHeadingTextColor"
              >{{heroSettings.copy}}</p>
            </div>
            <div
              class="collection-hero__with-image-image"
              :style="`backgroundImage: url(${mobileImageUrl})`"
            ></div>
          </div>
          <div class="collection-hero__no-image" v-else>
            <div class="collection-hero__text" :class="textAlignmentClass">
              <collection-breadcrumbs-b v-bind="breadcrumbs"></collection-breadcrumbs-b>
              <h1
                :class="[currentHeadingColor, $mq !== 'mobile' ? 'h4' : 'h3']"
              >{{currentHeadingText}}</h1>
              <p
                class="body-sm-mobile body-md-tablet-up"
                v-if="heroSettings.copy"
                :class="currentHeadingTextColor"
              >{{heroSettings.copy}}</p>
            </div>
          </div>
        </div>
        <div class="collection-hero t-o" v-if="alternateSettings.layout === 'Textbox Overlaid'">
          <div
            class="collection-hero__with-image"
            v-if="heroSettings.imageUrl"
            :class="[layoutClass, layoutAlignmentClass]"
          >
            <div class="collection-hero__text" :class="[currentBgColor, textAlignmentClass]">
              <collection-breadcrumbs-b v-bind="breadcrumbs"></collection-breadcrumbs-b>
              <h1
                :class="[currentHeadingColor, $mq !== 'mobile' ? 'h4' : 'h3']"
              >{{currentHeadingText}}</h1>
              <p
                class="body-sm-mobile body-md-tablet-up"
                v-if="heroSettings.copy"
                :class="currentHeadingTextColor"
              >{{heroSettings.copy}}</p>
            </div>
            <div
              class="collection-hero__with-image-image"
              :style="`backgroundImage: url(${mobileImageUrl})`"
            ></div>
          </div>
        </div>
      </div>
      <div v-else :class="currentBgColor">
        <div class="container">
          <div class="collection-hero t-d">
            <div
              class="collection-hero__with-image"
              v-if="heroSettings.imageUrl"
              :class="[layoutClass, layoutAlignmentClass]"
            >
              <div class="collection-hero__text" :class="textAlignmentClass">
                <collection-breadcrumbs-b v-bind="breadcrumbs"></collection-breadcrumbs-b>
                <h1
                  :class="[currentHeadingColor, $mq !== 'mobile' ? 'h4' : 'h3']"
                >{{currentHeadingText}}</h1>
                <p
                  class="body-sm-mobile body-md-tablet-up"
                  v-if="heroSettings.copy"
                  :class="currentHeadingTextColor"
                >{{heroSettings.copy}}</p>
              </div>
              <div
                class="collection-hero__with-image-image"
                :style="`backgroundImage: url(${mobileImageUrl})`"
              ></div>
            </div>
            <div class="collection-hero__no-image" v-else>
              <div class="collection-hero__text" :class="textAlignmentClass">
                <collection-breadcrumbs-b v-bind="breadcrumbs"></collection-breadcrumbs-b>
                <h1
                  :class="[currentHeadingColor, $mq !== 'mobile' ? 'h4' : 'h3']"
                >{{currentHeadingText}}</h1>
                <p
                  class="body-sm-mobile body-md-tablet-up"
                  v-if="heroSettings.copy"
                  :class="currentHeadingTextColor"
                >{{heroSettings.copy}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CollectionBreadcrumbsB from '@/scripts/components/collection/CollectionBreadcrumbsB';

export default {
  name: 'CollectionHero',
  components: {
    CollectionBreadcrumbsB,
  },
  props: {
    defaultSettings: {
      type: Object,
      required: true,
      default: () => ({
        heading: String,
        backgroundColor: String,
        headingColor: String,
        textColor: String,
      }),
    },
    breadcrumbs: {
      type: Object,
      required: true,
      default: () => ({
        collectionTitle: String,
        collectionHandle: String,
      }),
    },
    customHeaderHtml: String,
    heroSettings: {
      type: Object,
      required: true,
      default: () => ({
        heading: String,
        copy: String,
        imageUrl: String,
        backgroundColor: String,
        headingColor: String,
        textColor: String,
      }),
    },
    alternateSettings: {
      type: Object,
      required: false,
      default: () => ({
        layout: String,
        layoutAlignment: String,
        textAlignment: String,
        mobileImage: String,
      }),
    },
  },
  mounted() {
    // this.$refs.main.innerHTML = this.customHeaderHtml;
    const containerDiv = document.createElement('div');
    containerDiv.innerHTML = this.customHeaderHtml;

    const sliderScript = containerDiv.querySelector('script');
    const elements = containerDiv.querySelectorAll('*');

    if (sliderScript && elements && elements.length) {
      const script = document.createElement('script');
      script.innerHTML = sliderScript.innerHTML;

      this.$refs.main.innerHTML = this.customHeaderHtml;

      this.$refs.main.appendChild(script);
    }
  },
  computed: {
    layoutClass() {
      const layout = this.alternateSettings.layout;

      if (layout) {
        if (layout === 'Textbox Overlaid') {
          return 'overlaid';
        }
        if (layout === 'Textbox Adjacent') {
          return 'adjacent';
        }
      }
      return undefined;
    },
    layoutAlignmentClass() {
      const alignment = this.alternateSettings.layoutAlignment;

      if (alignment) {
        if (alignment === 'Left') {
          return 'align-left';
        }
        if (alignment === 'Right') {
          return 'align-right';
        }
      }
      return undefined;
    },
    textAlignmentClass() {
      const alignment = this.alternateSettings.textAlignment;

      if (alignment) {
        if (alignment === 'Left') {
          return 'text-left';
        }
        if (alignment === 'Center') {
          return 'text-center';
        }
      }
      return this.heroSettings.imageUrl.length ? 'text-left' : 'text-center';
    },
    currentBgColor() {
      return this.heroSettings.backgroundColor
        ? this.getClass(this.heroSettings.backgroundColor)
        : this.defaultSettings.backgroundColor;
    },
    currentHeadingColor() {
      return this.heroSettings.headingColor
        ? this.getClass(this.heroSettings.headingColor)
        : this.defaultSettings.headingColor;
    },
    currentHeadingText() {
      return this.heroSettings.heading
        ? this.heroSettings.heading
        : this.defaultSettings.heading;
    },
    currentHeadingTextColor() {
      return this.heroSettings.textColor
        ? this.getClass(this.heroSettings.textColor)
        : this.defaultSettings.textColor;
    },
    mobileImageUrl() {
      return this.$mq === 'mobile' && this.alternateSettings.mobileImage
        ? this.alternateSettings.mobileImage
        : this.heroSettings.imageUrl;
    },
  },
  methods: {
    getClass(metafield) {
      return metafield.split(' - ')[1];
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  padding: 0;
  background-color: transparent;
  @include mobile-only {
    padding: 0;
  }
}
.collection-hero {
  width: 100%;
  min-height: 400px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid $color-off-white;

  @include mobile-only {
    min-height: 0;
    max-width: 344px;
    margin: 0 auto;
  }

  &__with-image,
  &__no-image {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    @include mobile-only {
      flex-direction: column;
    }
    &-image {
      width: 54.19%;
      height: 352px;
      background-size: cover;
      background-position: center;
      @include mobile-only {
        width: 100%;
        height: 176px;
      }
    }
  }

  &__text {
    padding: 20px 32px;
    width: 45.81%;
    min-height: 256px;
    max-width: 375px;
    min-width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    @include mobile-only {
      padding: 24px 13px;
      width: 100%;
      text-align: center;
      min-height: 0;
    }
    h1 {
      margin: 0;
    }
    p {
      margin: 16px 0 0;
      @include mobile-only {
        margin: 8px 0 0;
      }
    }
  }

  &__with-image {
    .collection-hero__text {
      @include tablet-up {
        padding-top: 0;
        padding-bottom: 0;
      }
    }
    &.align-left {
      flex-direction: row;
      @include mobile-only {
        flex-direction: column-reverse;
      }
    }
    &.align-right {
      flex-direction: row-reverse;
      @include mobile-only {
        flex-direction: column-reverse;
      }
    }
    &.overlaid {
      .collection-hero__text {
        box-shadow: 1px 2px 4px -1px rgba(0, 0, 0, 0.2);
        border-radius: 4px;

        @include mobile-only {
          padding: 24px 13px;
          width: 90%;
          text-align: center;
          margin-top: -64px;
          margin-bottom: 32px;
          z-index: 5;
          box-shadow: 1px 1px 2px -1px rgba(0, 0, 0, 0.2);
        }
      }
      .collection-hero__with-image-image {
        width: 80%;
        @include mobile-only {
          width: 100%;
        }
      }
      .collection-hero__text {
        @include tablet-up {
          padding: 32px;
          margin: 16px 0;
          z-index: 5;
        }
      }
      &.align-left {
        .collection-hero__text {
          @include tablet-up {
            margin-right: -128px;
          }
        }
      }
      &.align-right {
        .collection-hero__text {
          @include tablet-up {
            margin-left: -128px;
          }
        }
      }
    }
  }
  &__no-image {
    .text-left {
      margin: 0;
      text-align: left;
    }
  }
}
.text-center {
  margin: 0 auto;
}
</style>
